import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

const DetailSection = ({ title, icon, children, color = 'primary' }) => {
  const theme = useTheme();
  return (
    <Paper variant="outlined" sx={{ p: { xs: 2, sm: 3 }, mb: 2, borderRadius: 2, borderColor: alpha(theme.palette[color].main, 0.2) }}>
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
        <Box sx={{ p: 0.75, borderRadius: 1.5, bgcolor: alpha(theme.palette[color].main, 0.1), color: `${color}.main` }}>
          {icon}
        </Box>
        <Typography variant="subtitle1" fontWeight={600}>{title}</Typography>
      </Stack>
      {children}
    </Paper>
  );
};

DetailSection.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
};

export default DetailSection;